import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useRef, useEffect, useState } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import cx from 'classnames';
import ModalDialogNoEscape from 'ui/components/modal-dialog';
import ModalDialog from '../ui/modal-dialog';
import ITSVideoPlayer from '../../utils/ITS-videoPlayer';
var t = i18n.getFixedT(null, 'terminal-dashboard');
var gt = i18n.getFixedT(null, 'app');
var RelatedCameraDetail = /*#__PURE__*/React.memo(function (props) {
  var _useState = useState({}),
      _useState2 = _slicedToArray(_useState, 2),
      videoPlayerData = _useState2[0],
      setVideoPlayerData = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      previewCamera = _useState4[0],
      setPreviewCamera = _useState4[1];

  var _useState5 = useState(null),
      _useState6 = _slicedToArray(_useState5, 2),
      tempSelectedCamera = _useState6[0],
      setTempSelectedCamera = _useState6[1];

  var _useState7 = useState(),
      _useState8 = _slicedToArray(_useState7, 2),
      error = _useState8[0],
      setError = _useState8[1];

  var id = props.id,
      onClose = props.onClose,
      dialogData = props.dialogData;
  var form_ref = useRef(null);

  var handleSelectPreviewCamera = function handleSelectPreviewCamera(data) {
    if (data) return setPreviewCamera(data);
    if (tempSelectedCamera) return setPreviewCamera(tempSelectedCamera);
  };

  useEffect(function () {
    return function () {
      setRelatedCameras(null);
      setTempSelectedCamera(null);
    };
  }, []);
  var fields = {};

  _.set(fields, 'relatedCameras', {
    label: t('lbl-related-camera'),
    editor: null,
    formatter: function formatter(val, row) {
      if (row.length === 0) return /*#__PURE__*/React.createElement("div", null, t('lbl-no-related-camera'));
      return /*#__PURE__*/React.createElement("div", {
        className: "relatedCameras-block"
      }, _.map(row, function (el) {
        return /*#__PURE__*/React.createElement("div", {
          className: cx('camera')
        }, /*#__PURE__*/React.createElement("span", {
          className: !_.isEmpty(previewCamera) && previewCamera.id === el.id ? 'selected' : '',
          onClick: function onClick() {
            return handleSelectPreviewCamera(el);
          }
        }, el.name));
      }));
    }
  }); // dailog action


  var actions = {};

  _.set(actions, 'cancel', {
    text: gt('global.lbl-close'),
    handler: onClose
  });

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ModalDialogNoEscape, {
    id: id,
    title: t('lbl-detail'),
    global: true,
    info: error,
    infoClassName: cx({
      'c-error': error
    }),
    actions: actions,
    closeAction: "cancel"
  }, /*#__PURE__*/React.createElement(React.Fragment, null, dialogData && dialogData.relatedCameras.length > 0 ? _.map(dialogData.relatedCameras, function (el) {
    return /*#__PURE__*/React.createElement("div", {
      className: "camera-card"
    }, /*#__PURE__*/React.createElement("div", {
      className: "camera-video"
    }, /*#__PURE__*/React.createElement("i", {
      className: "far fa-play-circle play-icon",
      onClick: function onClick() {
        return setVideoPlayerData(el);
      }
    })), /*#__PURE__*/React.createElement("div", {
      className: "camera-info"
    }, /*#__PURE__*/React.createElement("p", {
      className: "camera-name",
      title: el.name
    }, el.name), /*#__PURE__*/React.createElement("p", {
      className: "camera-area",
      title: el.location
    }, el.location)));
  }) : /*#__PURE__*/React.createElement("div", null, t('lbl-no-related-camera')))), !_.isEmpty(videoPlayerData) && /*#__PURE__*/React.createElement(VideoPlayerDialog, {
    data: videoPlayerData,
    onClose: function onClose() {
      return setVideoPlayerData({});
    }
  }));
});
RelatedCameraDetail.defaultProps = {
  id: 'g-related-camera-detail'
};
RelatedCameraDetail.propTypes = {
  id: PropTypes.string
};
export default RelatedCameraDetail;

var VideoPlayerDialog = function VideoPlayerDialog(props) {
  var data = props.data,
      onClose = props.onClose; // dailog action

  var actions = {};

  _.set(actions, 'cancel', {
    text: gt('global.lbl-close'),
    handler: onClose
  });

  return /*#__PURE__*/React.createElement(ModalDialog, {
    id: "videoPlayer-dialog",
    title: t('lbl-live-camera'),
    global: true,
    actions: actions,
    closeAction: "cancel"
  }, /*#__PURE__*/React.createElement("div", {
    className: "camera-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "camera-video"
  }, /*#__PURE__*/React.createElement(ITSVideoPlayer, {
    videoData: data
  })), /*#__PURE__*/React.createElement("div", {
    className: "camera-info"
  }, /*#__PURE__*/React.createElement("p", {
    className: "camera-name"
  }, data.name), /*#__PURE__*/React.createElement("p", {
    className: "camera-area"
  }, data.location))));
};